import * as React from 'react';
import TaskCardSubtitleV1 from '../pages/tasks/TaskCardSubtitle.v1';
import TaskCardSubtitleV2 from '../pages/tasks/TaskCardSubtitle.v2';
export var VERSION1 = 'Verzió 1';
export var VERSION2 = 'Verzió 2';
export function getCardDisplayOptions() {
    return [VERSION1, VERSION2];
}
export function getTaskCardPrimaryTitle(option, task) {
    switch (option) {
        case VERSION1:
            return React.createElement("span", null,
                task.title,
                task.isReserve ? ' (tart.)' : '');
        case VERSION2:
            return React.createElement("b", null,
                task.competency,
                task.isReserve ? ' (tart.)' : '');
        default:
            return null;
    }
}
export function getTaskCardSubtitle(option, task) {
    switch (option) {
        case VERSION1:
            return React.createElement(TaskCardSubtitleV1, { task: task });
        case VERSION2:
            return React.createElement(TaskCardSubtitleV2, { task: task });
        default:
            return null;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/models/CardDisplayVersions.tsx
// module id = 124
// module chunks = 0